<template>
    <a-modal v-model="visible" :title="title" :width="width" centered :maskClosable="false" :keyboard="false">
        <a-spin :spinning="loading">
            <a-form class="fun-edit-form" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                <a-row :gutter="[0, 6]">
                    <a-col :span="12">
                        <a-form-item label="序号">
                            <a-input-number ref="xh" v-model="editData.xh" :min="0" style="width:100%" disabled />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="[0, 6]">
                    <a-col :span="12">
                        <a-form-item label="专业编号" required>
                            <a-input-search read-only ref="zybh" @search="isShow_zyxx = true" v-model="editData.zybh" />
                            <FGDataSelect :isShow.sync="isShow_zyxx" selectNo="JC1002" @saveselect="saveEvent_zyxx(arguments)"></FGDataSelect>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="专业名称">
                            <a-input ref="zymc" v-model="editData.zymc" disabled />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="[0, 6]">
                    <a-col :span="12">
                        <a-form-item label="咨询项目数|规划" required>
                            <a-input-number ref="zxxms_gh" v-model="editData.zxxms_gh" :min="0" :precision="0" style="width:100%" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="咨询项目数|项目建议书" required>
                            <a-input-number ref="zxxms_xmjys" v-model="editData.zxxms_xmjys" :min="0" :precision="0" style="width:100%" />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="[0, 6]">
                    <a-col :span="12">
                        <a-form-item label="咨询项目数|可研报告" required>
                            <a-input-number ref="zxxms_kybg" v-model="editData.zxxms_kybg" :min="0" :precision="0" style="width:100%" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="咨询项目数|项目申请报告" required>
                            <a-input-number ref="zxxms_xmsqbg" v-model="editData.zxxms_xmsqbg" :min="0" :precision="0" style="width:100%" />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="[0, 6]">
                    <a-col :span="12">
                        <a-form-item label="咨询项目数|资金申请报告" required>
                            <a-input-number ref="zxxms_zjsqbg" v-model="editData.zxxms_zjsqbg" :min="0" :precision="0" style="width:100%" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="咨询项目数|评估" required>
                            <a-input-number ref="zxxms_pg" v-model="editData.zxxms_pg" :min="0" :precision="0" style="width:100%" />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="[0, 6]">
                    <a-col :span="12">
                        <a-form-item label="咨询项目数|节能评审" required>
                            <a-input-number ref="zxxms_jnps" v-model="editData.zxxms_jnps" :min="0" :precision="0" style="width:100%" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="咨询项目数|工程项目管理" required>
                            <a-input-number ref="zxxms_gcxmgl" v-model="editData.zxxms_gcxmgl" :min="0" :precision="0" style="width:100%" />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="[0, 6]">
                    <a-col :span="12">
                        <a-form-item label="固定资产投资额" required>
                            <a-input-number
                                ref="gdzctze"
                                v-model="editData.gdzctze"
                                :min="0"
                                :step="0.01"
                                :formatter="
                                    (value) => {
                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                    }
                                "
                                :parser="
                                    (value) => {
                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                    }
                                "
                                style="width:100%"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="评估咨询项目|核增额" required>
                            <a-input-number
                                ref="pgzxhze"
                                v-model="editData.pgzxhze"
                                :min="0"
                                :step="0.01"
                                :formatter="
                                    (value) => {
                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                    }
                                "
                                :parser="
                                    (value) => {
                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                    }
                                "
                                style="width:100%"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="[0, 6]">
                    <a-col :span="12">
                        <a-form-item label="评估咨询项目|核减额" required>
                            <a-input-number
                                ref="pgzxhje"
                                v-model="editData.pgzxhje"
                                :min="0"
                                :step="0.01"
                                :formatter="
                                    (value) => {
                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                    }
                                "
                                :parser="
                                    (value) => {
                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                    }
                                "
                                style="width:100%"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="[0, 9]">
                    <a-col :span="24">
                        <a-form-item label="备注" :label-col="{ span: 3 }" :wrapper-col="{ span: 18 }">
                            <a-textarea ref="bz" :rows="3" v-model="editData.bz" />
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>
        </a-spin>
        <template v-slot:footer>
            <a-button @click="onClose" style="margin-right:8px;">
                取消
            </a-button>
            <a-button type="primary" :loading="saving || loading" @click="onSave">
                保存
            </a-button>
        </template>
    </a-modal>
</template>

<script>
export default {
    name: "QqxmAdd",
    props: ["showEdit", "xh", "dataId", "qqxmbid"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 父级菜单下拉列表数据
            tableData: [],
            tableDataLoading: false,
            // 系统功能数据

            // 编辑数据
            editData: {},
            editDataLoading: false,
            isShow_zyxx: false
        };
    },
    computed: {
        title() {
            return this.dataId ? "编辑" : "新增";
        },
        visible: {
            get() {
                return this.showEdit;
            },
            set(newVal) {
                this.$emit("update:showEdit", newVal);
            }
        },
        width() {
            return 1600;
        },
        loading() {
            return this.tableDataLoading || this.editDataLoading;
        }
    },
    watch: {
        visible: {
            handler(newVal) {
                // 显示编辑窗口时加载数据
                if (newVal) {
                    if (!this.dataId) {
                        // 新增，设置默认值
                        this.editData = {
                            isnew: true,
                            id: this.$FG_util.uuid(),
                            xh: this.xh,
                            qqxmbid: this.qqxmbid
                        };
                    } else {
                        this.loadData();
                    }
                    // 设置光标位置
                    this.$nextTick(() => {
                        this.$refs.xh.focus();
                    });
                }
            },
            immediate: true
        }
    },
    methods: {
        saveEvent_zyxx(val) {
            if (val && val.length > 0) {
                this.editData.zyid = val[0][0].ID;
                this.editData.zybh = val[0][0].ZYBH;
                this.editData.zymc = val[0][0].ZYMC;
            }
        },
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/dwdcgl/dwdc/selectQqxmById",
                    {
                        id: this.dataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002").then(() => (this.visible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.visible = false;
                    }
                });
        },
        //保存
        onSave() {
            // 表单校验
            if (!this.editData.zybh) {
                this.$FG_message.error("P0001", "专业编号").then(() => this.$refs.zybh.focus());
                return;
            }
            if (!this.editData.zxxms_gh) {
                this.$FG_message.error("P0001", "咨询项目数|规划").then(() => this.$refs.zxxms_gh.focus());
                return;
            }
            if (!this.editData.zxxms_xmjys) {
                this.$FG_message.error("P0001", "咨询项目数|项目建议书").then(() => this.$refs.zxxms_xmjys.focus());
                return;
            }
            if (!this.editData.zxxms_xmjys) {
                this.$FG_message.error("P0001", "咨询项目数|项目建议书").then(() => this.$refs.zxxms_xmjys.focus());
                return;
            }
            if (!this.editData.zxxms_kybg) {
                this.$FG_message.error("P0001", "咨询项目数|可研报告").then(() => this.$refs.zxxms_kybg.focus());
                return;
            }
            if (!this.editData.zxxms_xmjys) {
                this.$FG_message.error("P0001", "咨询项目数|项目申请报告").then(() => this.$refs.zxxms_xmjys.focus());
                return;
            }
            if (!this.editData.zxxms_zjsqbg) {
                this.$FG_message.error("P0001", "咨询项目数|资金申请报告").then(() => this.$refs.zxxms_zjsqbg.focus());
                return;
            }
            if (!this.editData.zxxms_pg) {
                this.$FG_message.error("P0001", "咨询项目数|评估").then(() => this.$refs.zxxms_pg.focus());
                return;
            }
            if (!this.editData.zxxms_jnps) {
                this.$FG_message.error("P0001", "咨询项目数|节能评审").then(() => this.$refs.zxxms_jnps.focus());
                return;
            }
            if (!this.editData.zxxms_gcxmgl) {
                this.$FG_message.error("P0001", "咨询项目数|工程项目管理").then(() => this.$refs.zxxms_gcxmgl.focus());
                return;
            }
            if (!this.editData.gdzctze) {
                this.$FG_message.error("P0001", "固定资产投资额").then(() => this.$refs.gdzctze.focus());
                return;
            }
            if (!this.editData.pgzxhze) {
                this.$FG_message.error("P0001", "评估咨询项目|核增额").then(() => this.$refs.pgzxhze.focus());
                return;
            }
            if (!this.editData.pgzxhje) {
                this.$FG_message.error("P0001", "评估咨询项目|核减额").then(() => this.$refs.pgzxhje.focus());
                return;
            }
            // 保存操作

            this.saving = true;
            this.$FG_http
                .post("./api/main/dwdcgl/dwdc/saveQqxm", {
                    data: this.editData
                })
                .then(({ success, data, errMsg }) => {
                    this.saving = false;
                    if (success) {
                        // 返回列表
                        this.visible = false;
                        // 通知父组件数据已更新
                        this.$emit("dataUpdated", this.editData.id);
                    } else {
                        this.$refs.xh.focus();
                    }
                });
        },
        // 取消
        onClose(e) {
            this.visible = false;
        }
    }
};
</script>
